import { useGlobalStore } from "@/store";
import WelcomeFlow from "../../components/WelcomeFlow";
import ThirdPartyLandingScreen from "../ThirdPartyWelcomePage";
import { useNavigate } from "react-router-dom";

export default function WelcomePage() {
  const { state } = useGlobalStore();
  const navigate = useNavigate();

  return (
    <>
      {state.isThirdPartyMember === true && (
        <ThirdPartyLandingScreen
          onContinue={() => {
            navigate("/login");
          }}
        />
      )}

      {state.isThirdPartyMember === false && <WelcomeFlow />}
    </>
  );
}
